// src/aiq/components/LiveTicker.tsx (Updated)

import React, { useState, useEffect, useRef } from 'react';
import { IconActivity } from './Icons';
import { useAiQ } from '../state/AiQState';

const TICKER_ITEMS = [
    { symbol: 'EUR/USD', price: 1.0845, change: 0.0002 },
    { symbol: 'USD/JPY', price: 150.23, change: -0.15 },
    { symbol: 'AAPL', price: 182.50, change: 1.20 },
    { symbol: 'TSLA', price: 175.40, change: -2.10 },
    { symbol: 'UST 10Y', price: 4.251, change: 0.025 },
    { symbol: 'J.P. Morgan', price: 185.20, change: 0.50 },
    { symbol: 'Brent', price: 82.50, change: -0.40 },
    { symbol: 'BTC/USD', price: 62450.0, change: 1200.0 },
];

const LiveTicker: React.FC = () => {
    const [prices, setPrices] = useState(TICKER_ITEMS);
    const { updateMarketData } = useAiQ();
    const updateRef = useRef(updateMarketData);

    // Keep ref current to avoid effect re-triggering
    useEffect(() => {
        updateRef.current = updateMarketData;
    }, [updateMarketData]);

    useEffect(() => {
        const interval = setInterval(() => {
            setPrices(current => {
                const next = current.map(item => {
                    const move = (Math.random() - 0.5) * (item.price * 0.001);
                    const newPrice = item.price + move;
                    return { ...item, price: newPrice };
                });

                // Throttled update to context (Update only one symbol per tick to avoid render storm)
                const randomItem = next[Math.floor(Math.random() * next.length)];
                // Use a microtask or timeout to ensure we are out of the render phase
                setTimeout(() => {
                    updateRef.current(randomItem.symbol, randomItem.price);
                }, 0);

                return next;
            });
        }, 60000); // Slower tick

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="bg-slate-900 text-white text-xs border-t border-slate-800 flex items-center h-8 overflow-hidden shrink-0">
            <div className="bg-blue-700 h-full px-3 flex items-center font-bold z-10 shadow-md">
                <IconActivity />
                <span className="ml-2">LIVE MARKET</span>
            </div>
            <div className="flex-1 overflow-hidden flex items-center">
                <div className="flex space-x-6 animate-marquee px-4">
                    {prices.map((item) => (
                        <div key={item.symbol} className="flex items-center space-x-2 whitespace-nowrap">
                            <span className="font-bold text-slate-400">{item.symbol}</span>
                            <span className="font-mono">{item.price.toFixed(item.symbol.includes('JPY') ? 2 : 4)}</span>
                            <span className={item.change >= 0 ? 'text-emerald-400' : 'text-red-400'}>
                                {item.change >= 0 ? '▲' : '▼'} {Math.abs(item.change).toFixed(2)}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
            <div className="bg-slate-900 h-full px-3 flex items-center text-slate-500 border-l border-slate-800 text-[10px] z-10">
                Data Delay: 0ms (Simulated Direct Feed)
            </div>
        </div>
    );
};

export default LiveTicker;